import styled from "@emotion/styled";
import StepperComponent from "@components/Stepper";
import { theme } from "@styles/theme";
import UploadIcon from "@components/icons/Upload";
const { sm, lg, xl, md } = theme.breakpoints;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  @media (max-width: ${xl}) {
    font-size: 11px;
  }
  @media (max-width: ${lg}) {
    font-size: 14px;
  }
  @media (max-width: ${sm}) {
    font-size: 12px;
  }
`;
export const Content = styled.div`
  background-color: #f3f5f7;
  flex-grow: 1;
  padding: 0 14em;
  @media (max-width: ${lg}) {
    padding: 0 5em;
  }
  @media (max-width: ${lg}) {
    padding: 0 2em;
  }
  display: flex;
  flex-direction: column;
`;
export const StepperContainer = styled.div`
  background: white;
  padding: 2em 0;
  border-radius: 1em;
  box-shadow: 0px 3px 6px #00000029;
  box-sizing: content-box;
  margin: 2em 0;
  @media (max-width: ${sm}) {
    font-size: 9px;
  }
`;
export const Stepper = styled(StepperComponent)``;

export const TimeLineContiner = styled.div`
  background-color: white;
  padding: 2em 0;
  box-sizing: border-box;
  margin: 2em 0;
  border-radius: 1em;
  box-sizing: content-box;
  box-shadow: 0px 3px 6px #00000029;
`;
export const TitleFile = styled.h3`
  color: #1b1c1e;
  font-family: "Poppins Regular";
  font-size: 1.2em;
`;
export const UploadContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 2em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
  @media (max-width: ${md}) {
    margin: 0;
    margin-top: 2em;
  }
`;
export const Description = styled.div`
  margin: 0 2em;
  width: 20ch;
  @media (max-width: ${sm}) {
    margin: 0;
    margin-right: 1em;
  }
`;
export const Label = styled.div`
  font-size: 1.1em;
  font-family: Poppins Regular;
  margin-bottom: 0.8em;
`;
export const Detail = styled.div`
  font-family: Poppins Ligth;
  font-size: 0.9em;
`;
export const FileContainer = styled.div`
  width: 7em;
  height: 7em;
  padding: 0.4em;
  box-sizing: border-box;
  background-color: #00000029;
`;
export const File = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  border: #707070 dashed 2px;
  height: 96%;
  cursor: pointer;
`;
export const Upload = styled(UploadIcon)`
  width: 2.5em;
`;
export const DownLoad = styled.a`
  background: #0085c8;
  padding: 1em 2em;
  border-radius: 1em;
  color: white;
  text-decoration: none;
  margin-bottom: 4em;
  font-size: 1em;
  font-family: Poppins Regular;
`;
